<template>
    <v-navigation-drawer
        id="pm-main-navigation"
        v-model="$store.state.app.drawer"
        dark
        :class="$theme.navbarBg"
        width="250"
        app
        touchless
        temporary
        @input="function(v) { $store.state.app.drawer = v }"
    >
        <div style="display: flex; flex-direction: column; width: 100%; height: 100%;">
            <div style="flex-grow: 1; overflow-x: hidden; overflow-y: auto;" class="navigation-menu-container">
                <v-toolbar height="70"
                            :style="expiredTrial ? 'opacity: .5' : ''"
                            :class="$route.name === 'home' ? $theme.primaryBg : $theme.primaryBg"
                           dark
                           flat
                           class="transparent"
                           @click="navigateToHome"
                >
                    <v-list class="pa-0">
                        <v-list-tile avatar tile>
                            <v-list-tile-avatar>
                                <img style="border-radius: 0;" alt="DentiCalc" :src="logoSrc">
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title style="font-size: 17px; overflow: visible;" class="white--text">
                                    <div style="overflow: visible; line-height: 13px; font-size: 17px;" v-if="packageName === 'com.denticalc.videos'">Dental Videos<br/><small class="f11">by DentiCalc</small></div>
                                    <div style="overflow: visible; line-height: 13px; font-size: 17px;" v-else-if="packageName === 'com.denticalc.calculator'">Dental Calculator<br/><small class="f11">by DentiCalc</small></div>
                                    <div style="overflow: visible; line-height: 13px; font-size: 17px;" v-else-if="packageName === 'com.denticalc.calculationtool'">Consultation Tool<br/><small class="f11">by DentiCalc</small></div>
                                    <template v-else>DentiCalc</template>
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-toolbar>

                <v-divider style="margin: 0 0 8px 0; border-color: hsla(0,0%,100%,.25);" />

                <!--div class="navigation-menu-item" @click="">
                        <v-avatar size="32">
                            <v-icon class="white--text">alert_circle_outline</v-icon>
                        </v-avatar>
                        <span class="navigation-menu-item--title white--text">Setup 75% complete</span>
                    </div>
                 <v-divider style="margin: 8px 0; border-color: hsla(0,0%,100%,.25);" /-->

                <template v-for="(item, i) in items">
                    <div v-if="item.key === 'separator'" :key="i">
                        <v-divider style="margin: 8px 0; border-color: hsla(0,0%,100%,.25);" />
                    </div>
                    <div v-else :style="item.disableOnExpired && expiredTrial ? 'opacity: .5' : ''" :class="$route.name === item.routeName ? 'blue accent-3' : ''" :key="i" class="navigation-menu-item" @click="menuClick(item)">
                        <v-avatar tile size="32" style="border-radius: 0!important;">
                            <v-icon v-if="!item.mdi" v-html="item.icon"  :style="item.hasWarning && item.warningText ? 'margin-top: 16px;' : ''" />
                            <mdi style="width: 22px; height: 22px; color: #fff;" size="16" v-if="item.mdi" :style="item.hasWarning && item.warningText ? 'margin-top: 16px;' : ''">{{item.mdi}}</mdi>

                            <svg v-if="item.hasWarning" style="pointer-events: none; filter: drop-shadow(1px 1px 0px #fff) drop-shadow(-1px 1px 0px #fff) drop-shadow(1px -1px 0px #fff) drop-shadow(-1px -1px 0px #fff); position: absolute; margin: 0px 0 0 -16px; width:20px;height:20px" viewBox="0 0 24 24">
                                <path fill="#e91e63" d="M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z" />
                            </svg>

                        </v-avatar>
                        <span class="navigation-menu-item--title white--text">
                            <span v-html="item.title" />
                            <b style="line-height: 1; font-weight: 600; margin-top: -4px; display: block; font-size: 12px;" v-if="item.hasWarning && item.warningText">{{ item.warningText }}</b>
                        </span>
                    </div>
                </template>

                <!--div style="text-align: center; margin-top: 40px;">
                    <v-icon style="font-size: 32px;" @click="$store.state.app.drawer = false">chevron_left</v-icon>
                </div-->
            </div>
            <div v-if="appVersion" style="padding: 12px 20px; color: rgba(255,255,255,.4); font-size: 12px;" @click="onVersionClick">
                v{{ appVersion }} b{{ flutterVersion }}
            </div>
            <v-dialog persistent v-model="showFlutterEventLog" @close="showFlutterEventLog = false" class="white">
                <div class="white" style="position: relative; padding: 16px; font-size: 12px;">
                    <v-btn style="position: sticky; top: 16px; right: 16px; float: right;" fab small @click="showFlutterEventLog = false"><v-icon>close</v-icon></v-btn>
                    <span class="blue--text text--darken-3" style="font-size: 16px;">Debug info</span><br/>
                    <small>DentiCalc v{{ appVersion }}</small>
                    <br/><br/>
                    <pre>{{ flutterEventLog }}</pre>
                </div>
            </v-dialog>
        </div>
    </v-navigation-drawer>
</template>

<style lang="scss">
    .navigation-menu-item {
        padding: 10px 0;
        cursor: pointer;
        position: relative;
    }
    .navigation-menu-item.active .navigation-menu-item--title.white--text {
        /*color: #e91e63!important*/
    }
    .navigation-menu-item.active {
        background: #e91e63!important
    }

    .v-navigation-drawer--temporary {
        .navigation-menu-item  {
            display: flex;

            .v-avatar {
                margin-left: 16px;
                margin-right: 12px;
            }

            .navigation-menu-item--title {
                line-height: 32px;
            }
        }
    }
</style>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
/* eslint-disable vue/no-async-in-computed-properties */
export default {
    components: {
        // PmAppSearch,
    },
    data: function() {
        return {
            // eslint-disable-next-line no-undef
            globals: globals,
            tabs: [],
            activeTab: null,
            visibleTabs: [],
            activeRoute: "",
            activeRouteSub: "",
            currentDate: "",
            // eslint-disable-next-line no-undef
            userName: globals.userData.fullName,
            activeMenu: null,
            searchDialog: false,
            appVersion: "",
            logoSrc: '',
            showFlutterEventLog: false,
            flutterEventLog: window.flutterEventLog,
            versionClickCounter: 0,
            expiredTrial: false,
            items: [],
            flutterVersion: 0,
        };
    },
    watch: {
        $route: function(to, from) {
            if (to.path.search("/patient/")>=0) {
                this.activeRouteSub = to.path.split("/")[3];
                this.activeRoute = "patient";
                this.activeMenu = this.items[0];
            } else if (to.path.search("/pricelist") >= 0) {
                this.activeRoute = "settings";
            } else {
                this.activeRoute = to.path.replace("/", "");
            }
        },
    },
    created() {
        this.appVersion = window.appVersion;

        // eslint-disable-next-line no-undef
        if (process && process.env.NODE_ENV === "development") {
            // eslint-disable-next-line no-undef
            this.logoSrc = require("../../../public/images/denti_calc_icon_20200619.png");
        } else {
            this.logoSrc = "/images/denti_calc_icon_20200619.png";
        }

        this.registerBusEvent("flutter:trialStatus", (data) => {
            this.getTrialStatus();
        });

        this.registerBusEvent("mainMenu:update", () => {
            this.items = this.getItems();
            this.$forceUpdate();
        });

         this.items = this.getItems();

         this.flutterVersion = this.getFlutterVersion();
    },
    computed: {
        packageName() {
            return window.packageName;
        },
    },
    mounted() {
        this.getTrialStatus();
    },

    methods: {
        getFlutterVersion() {
            return typeof window.version !== "undefined" ? window.version : 0;
        },
        getItems() {
            const items = [];

            if (window.packageName === 'com.denticalc.4in1') {
                items.push({
                    disableOnExpired: true,
                    key: "button",
                    routeName: "animations",
                    icon: "play_circle_outline",
                    title: this.$t("menu.animations"),
                    callback: () => {
                        this.$router.push("/animations").catch((err) => {});
                    },
                });
                items.push({
                    disableOnExpired: true,
                    key: "button",
                    routeName: "gallery",
                    mdi: "image-outline",
                    title: this.$t("photos.title"),
                    callback: () => {
                        this.$router.push("/gallery").catch((err) => {});
                    },
                });
                items.push({
                    disableOnExpired: true,
                    key: "button",
                    routeName: "calculator",
                    icon: "percent",
                    title: this.$t("menu.calculator"),
                    callback: () => {
                        this.$router.push("/calculator").catch((err) => {});
                    },
                });
                items.push({
                    disableOnExpired: true,
                    key: "button",
                    routeName: "plan",
                    mdi: "account-outline",
                    title: this.$t("menu.treatment_plan"),
                    callback: () => {
                        this.$router.push("/plan").catch((err) => {});
                    },
                });
                items.push({
                    key: "separator",
                });


                // return items;
            }

            items.push({
                disableOnExpired: true,
                key: "button",
                routeName: "settings",
                icon: "cog_outline",
                title: this.$t("menu.settings", this.$store.state.language),
                callback: () => {
                    if (!this.expiredTrial) this.$router.push("/settings").catch((err) => {});
                },
            });

            if (!window.packageName || window.packageName === "com.denticalc.calculator" || window.packageName === "com.denticalc.calculationtool" || window["packageName"] === "com.denticalc.4in1") {
                items.push({
                    disableOnExpired: true,
                    key: "button",
                    routeName: "pricelist",
                    icon: "coin",
                    title: this.$t("menu.pricelist", this.$store.state.language),
                    hasWarning: localStorage.getItem('priceListVisited') !== "true",
                    warningText: this.$t("welcome.warning_prices", this.$store.state.language),
                    callback: () => {
                        if (!this.expiredTrial) this.$router.push("/pricelist").catch((err) => {
                        });
                    },
                });
            }

            if (!window.packageName || window["packageName"] === "com.denticalc.pro" || window["packageName"] === "com.denticalc.4in1") {
                items.push({
                    disableOnExpired: true,
                    key: "history",
                    routeName: "history",
                    title: this.$t("menu.history", this.$store.state.language),
                    icon: "folder_clock_outline",
                    callback: () => {
                        if (!this.expiredTrial) this.$router.push("/history").catch((err) => {
                        });
                    },
                });
            }

            items.push({
                key: "separator",
            });

            if (!("packageName" in window) || window["packageName"] === null || window["packageName"] === "com.denticalc.pro" || window["packageName"] === "com.denticalc.4in1") {
            // if (!window.packageName) {
                items.push({
                    disableOnExpired: false,
                    key: "subscriptions",
                    routeName: "subscriptions",
                    icon: "credit_card_outline",
                    title: this.$t("menu.subscriptions", this.$store.state.language),
                    callback: () => {
                        this.$router.push("/addons").catch(() => {});
                    },
                });

                items.push({
                    key: "separator",
                });
            }

            if (!window.packageName || window.packageName === "com.denticalc.calculationtool") {
                items.push({
                    disableOnExpired: true,
                    key: "button",
                    routeName: "tutorial",
                    icon: "lifebuoy",
                    hasWarning: !this.isTutorialViewed(),
                    warningText: this.$t("welcome.warning_tutorial", this.$store.state.language),
                    title: this.$t("support.start_tutorial", this.$store.state.language),
                    callback: () => {
                        // setUserProperty log the event too
                        // window.Tracker.logEvent({
                        //     event_name: "tutorial_watched",
                        //     event_label: "tutorial",
                        // });

                        window.Tracker.setUserProperty("tutorial_watched", 1, {
                            event_name: "tutorial_watched",
                            event_label: "tutorial",
                            event_value: 1,
                        });

                        if (!this.expiredTrial) {
                            localStorage.setItem("tutorialMode", "true");
                            this.$bus.$emit("tutorial.start");
                        }
                    },
                });
            }

            items.push({
                disableOnExpired: false,
                key: "button",
                routeName: "support",
                icon: "help",
                title: this.$t("menu.support", this.$store.state.language),
                callback: () => {
                    this.$router.push("/support").catch((err) => {});
                },
            });

            if (window.packageName !== 'com.denticalc.4in1') items.push({
                disableOnExpired: false,
                key: "button",
                routeName: "feedback",
                icon: "comment_processing_outline",
                title: this.$t("support.send_feedback", this.$store.state.language),
                callback: () => {
                    this.$router.push("/feedback").catch((err) => {});
                },
            });

            return items;
        },
        isTutorialViewed() {
            const t = parseFloat(localStorage.getItem('tutorialViewed'));
            if (isNaN(t)) return false;
            return t > 30;
        },
        navigateToHome() {
            if (!this.expiredTrial) this.$router.push('/').catch(error => {
                captureException(error);

                this.$store.state.app.drawer = false;
            });
        },
        getTrialStatus() {
            this.expiredTrial = localStorage.getItem("trialStatus") === "true";
        },
        menuClick(item) {
            if(this.$route.name === item.routeName) {
                this.$store.state.app.drawer = false;
                return;
            }


            if (item.key === "patient" && !this.$store.state.activePatient.id) {
                return false;
            }

            this.activeMenu = item;

            if (typeof item.callback === "function") {
                item.callback();
            }

            // this.$store.state.app.drawer = false;
        },
        confirmLogout: function() {
            this.$root.showNotification({
                color: "warning",
                title: this.$t("navigation_drawer.confirm_logout"),
                buttons: [
                    {
                        text: this.$t("core.btn_cancel"),
                    },
                    {
                        text: this.$t("navigation_drawer.logout"),
                        callback: () => {
                            this.$router.push("/logout");
                        },
                    },
                ],
            });
        },

        handleCallback: function(cb) {
            const activeComponent = this.$root.$refs["component"].$refs["component"];
            activeComponent[cb].call();
        },

        onVersionClick() {
            this.versionClickCounter++;

            if (this.versionClickCounter === 4) {
                this.showFlutterEventLog = true;
                this.versionClickCounter = 0;
            }
        },
    },
};
</script>

<style>
    #pm-main-navigation .v-list.v-list--two-line .v-list__tile {
        height: 54px!important;
    }
    #pm-main-navigation .v-list.v-list--two-line .v-select__selections .v-list__tile {
        color: #fff!important;
        height: 28px!important;
        font-size: 16px!important;
    }
    #pm-main-navigation .v-list.v-list--two-line .v-list__group__items .v-list__tile {
        height: 44px!important;
    }
    #pm-main-navigation .patient-selector-container .v-input__icon i  {
        margin-left: -20px;
        color: #fff!important;
    }
    #pm-main-navigation .patient-selector-container .v-input__slot:before {
        display: none!important;
    }

    #pm-main-navigation .patient-selector-container .v-text-field .v-input__slot {
        padding: 0;
        margin: 0;
    }

    #pm-main-navigation .active {
        background: rgba(0,0,0,.1);
    }

    #pm-main-navigation .active .v-list__tile--link:hover, #pm-main-navigation .active.v-list__tile--link:hover, #pm-main-navigation .active .v-list__group__header--active:hover, #pm-main-navigation .active .v-list__group__header:hover {
        background: none!important;
    }
    #pm-main-navigation .v-list__group__header .v-list__tile--link:hover {
        background: none!important;
    }
    #pm-main-subnavigation-floating .v-avatar {
        width: 28px!important;
    }
</style>
